import { actionTypes } from '../actions/accessory'

const initialState = {
  isCountable: true,
  everySixteenAccessories: []
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.UPDATE_COUNTER_CLICKED_TIME:
      return {
        ...state,
        isCountable: payload.isCountable,
        everySixteenAccessories: payload.everySixteenAccessories
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/accessory.js